module.exports = __webpack_public_path__ + "static/media/big_avatar_1.4849312d.png";